import React from "react";
import "./Terms.scss";

const Terms = (props) => {
  return (
    <div className="Terms">
      <p>{props.toc}</p>
      <div className="termsBottom" onClick={props.onSave}>
        <button>Jag accepterar villkoren</button>
      </div>
    </div>
  );
};

export default Terms;
